import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ValidationService } from '../../../common/validationservice';
import { MainAppComponent } from '../../../layout/layout.component';
import { CountryModel, LabsModel } from '../../../common/viewModels/Admin/CustomerModel';
import { GraphTempTypeDDLModel } from '../../../common/viewModels/Analysis/SampleModel';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { FileDetailsModel } from '../../../common/viewModels/Analysis/SampleModel';
import { SuccessMessagesEnum } from '../../../common/enumcontainer.enum';
import { FormatService } from '../../../common/formatService';

@Component({
  selector: 'addeditcustomer',
  templateUrl: './addeditcustomer.component.html',
  styleUrls: ['./addeditcustomer.component.scss']
})

export class AddEditCustomer implements OnInit {
  countryCtrl: FormControl;
  customerForm: FormGroup;
  lstCountries: CountryModel[];
  lstCountriesTemp: CountryModel[];
  lstGraphTypes: GraphTempTypeDDLModel[];
  lstReportTypes: any[];
  filteredCountries: any;
  showtxtState: boolean = true;
  showddrState: boolean = false;
  lstStates: any[];
  customerId: number;
  ShowLogoType: boolean = false;
  ShowLogoUpload: boolean = false;
  imageFile: FormData = new FormData();
  LogoDetails: FileDetailsModel = new FileDetailsModel();
  IsLogoValid: boolean = true;
  baseUrl: string;
  CustomerLogoPath: string;
  lstLabs: LabsModel[];
  isSubmitted: boolean = false;
  emailEx = '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$';
  mobileNumberPattern = '^[0-9+_@#%$!&-]+$';

  constructor(public _router: Router, private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute,
    private _validationService: ValidationService, private _mApp: MainAppComponent,
    private _toastrService: ToastrService, private _formatService: FormatService) {
    //this.lstCountries=this.customerForm.value
    this.countryCtrl = new FormControl();
    this.filteredCountries = this.countryCtrl.valueChanges
      .startWith(null)
      .map(name => this.filterCountries(name));
  }

  filterCountries(val: string) {
    return val ? this.lstCountries.filter(s => s.Name.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.lstCountries;
  }

  ngOnInit() {
    this.customerForm = this._formBuilder.group({
      CustomerId: [0],
      Name: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])],
      LandlineNo: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(20), Validators.pattern(this.mobileNumberPattern)])],
      MobileNo: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(20), Validators.pattern(this.mobileNumberPattern)])],
      Fax: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50)])],
      Email: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50), Validators.pattern(this.emailEx)])],
      Website: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50)])],
      LabId: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList])],
      Address1: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(150)])],
      Address2: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(150)])],
      City: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50)])],
      State: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50)])],
      CountryId: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList])],
      Zip: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(10)])],
      ContactPersonName: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(80)])],
      ContactNumber: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(20), Validators.pattern(this.mobileNumberPattern)])],
      ContactEmail: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50), Validators.pattern(this.emailEx)])],
      ReportTemplateTypeId: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList])],
      GraphTemplateTypeId: [0],
      PoNumber: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50)])],
      PoStartDate: [null],
      PoEndDate: [null],
      HasCustomerLogo: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList])],
      IsAlongWithPetrolabsLogo: [''],
      CustomerLogoPath: ['']
    })

    this.GetCountries();
    this.GetLabs();
    this.GetReportTemplatesMinInfoList();
    this.GetGraphTemplateTypesForDDL();
    if (this._route.snapshot.params['id'] != null && this._route.snapshot.params['id'] != undefined && this._route.snapshot.params['id'] != 0) {
      this.customerId = this._route.snapshot.params['id'];
      this.GetCustomersById(this._route.snapshot.params['id']);
    }
    this.baseUrl = this._appUrl.baseUrl;
  }

  filter(val) {

    this.lstCountries = this.lstCountriesTemp.filter(m => m.Name.toLowerCase().indexOf(val.toLowerCase()) === 0);
  }

  displayFn(country) {
    return country ? country.Name : country;
  }


  GetCustomersById(id: number) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetCustomerById + this._route.snapshot.params['id'])
      .subscribe(
        data => {

          if (data.json() != null) {
            var response = data.json().Result;
            response.PoStartDate = this._formatService.formatNewDate(response.PoStartDate);
            response.PoEndDate = this._formatService.formatNewDate(response.PoEndDate);
            this.CustomerLogoPath = response.CustomerLogoPath;
            this.LogoDetails.FilePath = response.CustomerLogoPath;
            this.customerForm.setValue(response);
            this.ShowHideState(response.CountryId, false);
            this.ShowHideLogoType(response.HasCustomerLogo);

          }
          this._mApp.HideLoader();
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  GetCountries() {
    this._http.get(this._appUrl.GetCountries)
      .subscribe(
        data => {
          this.lstCountries = data.json().Result;
          this.lstCountriesTemp = data.json().Result;
        },
        error => {
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  GetLabs() {
    this._http.get(this._appUrl.GetCustLabs)
      .subscribe(
        data => {
          let lstLabs = data.json().Result;
          if (this._mApp.currentUserLabIds && lstLabs)
            lstLabs = lstLabs.filter(m => this._mApp.currentUserLabIds.includes(m.LabId));
          this.lstLabs = lstLabs;
        },
        error => {
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  onSubmit(isSaveNext) {
    this.isSubmitted = true;
    if (this.customerForm.valid && this.IsLogoValid) {
      let customersDto = this.customerForm.value;

      customersDto.PoStartDate = this._formatService.formatDate(customersDto.PoStartDate);
      customersDto.PoEndDate = this._formatService.formatDate(customersDto.PoEndDate);

      if (this.LogoDetails != null && this.LogoDetails != undefined) {
        customersDto.CustomerLogoDetails = this.LogoDetails;
      }
      this._mApp.ShowLoader();
      this._http.post(this._appUrl.AddCustomer, customersDto)
        .subscribe(
          data => {
            this._mApp.HideLoader();
            let id = 0;
            if (data.json().Result == SuccessMessagesEnum.UpdatedSuccessfully) {
              this._toastrService.success("Customer details updated successfully", '');
              id = this.customerId;
            }
            else {
              this._toastrService.success("Customer details added successfully", '');
              id = data.json().Result;
            }
            if (isSaveNext)
              this._router.navigate(['/customerchars', id])
            else
              this._router.navigate(['/CustomerList'])
          },
          error => {
            this._mApp.HideLoader();
            this._toastrService.error(error.json().Result, '');
          }
        );
    }
  }

  Clear() {
    this.customerForm.reset();
  }

  GetReportTemplatesMinInfoList() {
    this._http.get(this._appUrl.GetReportTemplatesMinInfoList)
      .subscribe(
        data => {
          if (data.json().Result != null)
            this.lstReportTypes = data.json().Result;
        },
        error => {
          this._toastrService.error(error.json().Result);
        }
      )
  }

  ShowHideState(val, isFromView) {
    if (isFromView)
      this.customerForm.controls['State'].setValue(null)
    if (val == 99) {
      this.showddrState = true;
      this.showtxtState = false;
      this.GetStates(val)
    }
    else {
      this.showddrState = false;
      this.showtxtState = true;
    }
  }

  ShowHideStateDdrTemp(event, country, isFromView) {
    if (event.source.selected) {
      this.ShowHideState(country.CountryId, isFromView);
    }
  }

  GetStates(countryId) {
    this._http.get(this._appUrl.GetStates + countryId)
      .subscribe(
        data => {
          if (data.json().Result != null)
            this.lstStates = data.json().Result;
        },
        error => {
          this._toastrService.error(error.json().Result);
        }
      )
  }

  GetGraphTemplateTypesForDDL() {
    this._http.get(this._appUrl.GetGraphTempleteTypeList)
      .subscribe(
        data => {
          this.lstGraphTypes = data.json().Result;
        },
        error => {
          this._toastrService.error(error.json().Result, '');
        }
      );
  }
  ShowHideLogoType(value) {

    if (value == true) {
      this.ShowLogoType = true;
      this.ShowLogoUpload = true;
      this.customerForm.controls['IsAlongWithPetrolabsLogo'].setValidators(Validators.required);
      this.customerForm.controls['IsAlongWithPetrolabsLogo'].updateValueAndValidity();
      if (this.LogoDetails.FilePath != null && this.LogoDetails.FilePath != undefined && this.LogoDetails.FilePath != "")
        this.IsLogoValid = true;
      else
        this.IsLogoValid = false;
    }
    else {
      this.ShowLogoType = false;
      this.ShowLogoUpload = false;
      this.IsLogoValid = true;
      this.customerForm.controls['IsAlongWithPetrolabsLogo'].setValidators(null);
      this.customerForm.controls['IsAlongWithPetrolabsLogo'].updateValueAndValidity();
    }
  }
  // ShowHideLogoUpload(value) {
  //   if (value == true || value == false)
  //     this.ShowLogoUpload = true;
  //   else
  //     this.ShowLogoUpload = false;
  // }

  uploadImage(event: any) {
    this.imageFile = new FormData();
    var element = ((window.event) ? (event.srcElement) : (event.currentTarget));
    var srcElement = event.srcElement || event.target;
    var files = srcElement.files;
    var size = files[0].size;
    let formData = new FormData();
    // this.hasImageFile = true;
    for (let i = 0; i < files.length; i++) {
      var ext = files[i].name.split('.').reverse()[0].toLowerCase();
      if (ext == "jpeg" || ext == "png" || ext == "gif" || ext == "jpg") {
        this.imageFile.append("uploads[]", files[i], files[i].name);
        var fileName = files[i].name.split('.').slice(0, -1).join('.');

      }
      else {
        this._toastrService.error("Please upload image files only");
        break;
      }
    }
    this.UploadInFolder(this.imageFile);

  }

  UploadInFolder(imageFile) {
    this._mApp.ShowLoader();
    this._http.postUpload(this._appUrl.UploadCustomerLogo, imageFile)
      .subscribe(
        data => {
          this._mApp.HideLoader();
          var res = data.json().Result;
          if (res != null && res != undefined) {
            this.LogoDetails.FileName = res.FileName;
            this.LogoDetails.FilePath = res.FilePath;
            this.IsLogoValid = true;
          }
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result);
        }
      );
  }

  DeleteCustomerLogo() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.DeleteCustomerLogo + this.customerId)
      .subscribe(
        data => {
          this._mApp.HideLoader();
          this._toastrService.success(data.json().Result);
          this.GetCustomersById(this.customerId);
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result);
        }
      )
  }

}
